import { render, staticRenderFns } from "./ModalRegisterLPFR.vue?vue&type=template&id=dee980f8&"
import script from "./ModalRegisterLPFR.vue?vue&type=script&lang=js&"
export * from "./ModalRegisterLPFR.vue?vue&type=script&lang=js&"
import style0 from "./ModalRegisterLPFR.vue?vue&type=style&index=0&id=dee980f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports